/**
 * Outward-facing web URLs used for native share sheets and deep links.
 *
 * On web we derive share URLs from `window.location.origin` (so previews and
 * self-hosted builds share their own host). On native there is no origin, so
 * we fall back to the canonical production host below.
 */
export const APP_WEB_BASE_URL = 'https://agapella.app';

/** Public Agapē Practice landing page — shared from the home hero banner. */
export const AGAPE_PRACTICE_URL = `${APP_WEB_BASE_URL}/agape-practice`;
